import type { EmploymentTemplate } from "services/api/company/staff.service";
import { toTemplateEnumOrFallback } from "../../../shared/staffEmploymentTemplate.logic";
import type { EmploymentDetailsForm } from "../../profilePanel.contract";

/**
 * Applies a selected employment template onto the employment form, leaving the
 * worker-specific fields (employee number, dates, tax table) untouched.
 */
export const applyEmploymentTemplateToEmploymentForm = (
  form: EmploymentDetailsForm,
  template: EmploymentTemplate,
): EmploymentDetailsForm => {
  return {
    ...form,
    employmentType: toTemplateEnumOrFallback(
      template.employmentType,
      form.employmentType,
    ),
    salaryType: toTemplateEnumOrFallback(template.salaryType, form.salaryType),
    employeeCategory: toTemplateEnumOrFallback(
      template.employeeCategory,
      form.employeeCategory,
    ),
    paymentType: toTemplateEnumOrFallback(
      template.paymentType,
      form.paymentType,
    ),
    role: template.role ?? form.role,
    salary:
      template.salaryValue == null ? form.salary : String(template.salaryValue),
    workPercentage:
      template.workPercentage == null
        ? form.workPercentage
        : String(Math.round(template.workPercentage * 100)),
    agreement: template.agreement ?? form.agreement,
    noticeDays:
      template.noticeDays == null
        ? form.noticeDays
        : String(template.noticeDays),
    vacationDays:
      template.vacationDays == null
        ? form.vacationDays
        : String(template.vacationDays),
    workplace: template.workplace ?? form.workplace,
  };
};
